<template><div><p align="center">
  <br>
   <a href="https://vux-demos.bobjoy.eu.org?x-page=v2-doc-home">
    <img src="https://img.picui.cn/free/2024/10/30/6721eec153bd7.png" width="100" alt="">
  </a>
  <br>
  <a href="https://vux-demos.bobjoy.eu.org?x-page=v2-doc-home">
    预览地址>>
  </a>
  <br>
  <br>
  <a href="https://github.com/airyland/vux">
    <img src="https://img.shields.io/github/stars/airyland/vux.svg?style=social&label=Star" alt="">
  </a>
  <a href="https://github.com/airyland/vux">
    <img src="https://img.shields.io/github/forks/airyland/vux.svg?style=social&label=Fork" alt="">
  </a>
  <a href="https://github.com/airyland/vux">
    <img src="https://img.shields.io/github/watchers/airyland/vux.svg?style=social&label=Watch" alt="">
  </a>
  <br>
  <br>
  <a href="https://github.com/airyland/vux/issues">
    <img src="https://img.shields.io/github/issues/airyland/vux.svg?style=flat-square" alt="">
  </a>
  <a href="https://github.com/airyland/vux/issues">
    <img src="https://isitmaintained.com/badge/resolution/airyland/vux.svg?style=flat-square" alt="">
  </a>
  <a href="https://github.com/airyland/vux/graphs/contributors">
    <img src="https://img.shields.io/github/contributors/airyland/vux.svg?style=flat-square" alt="">
  </a>
  <br>
  <a href="https://www.npmjs.com/package/vux">
    <img src="https://img.shields.io/npm/l/vux.svg?style=flat-square" alt="">
  </a>
  <a href="https://www.npmjs.com/package/vux">
    <img src="https://img.shields.io/npm/v/vux.svg?style=flat-square" alt="">
  </a>
  <a href="https://www.npmjs.com/package/vux">
    <img src="https://img.shields.io/npm/dm/vux.svg?style=flat-square" alt="">
  </a>
  <a href="https://www.npmjs.com/package/vux">
    <img src="https://img.shields.io/npm/dt/vux.svg?style=flat-square" alt="">
  </a>
  <br>
  <br>
</p>
<div class="warning">
<p>VUX 必须配合 <code>vux-loader</code> 使用，请按照<a href="https://github.com/airyland/vux/tree/v2/packages/vue-cli-3-example">https://github.com/airyland/vux/tree/v2/packages/vue-cli-3-example</a>配置。<br></p>
<p><strong>less@3.x</strong> 有严重的兼容问题，请暂时使用 <strong>less@^2.7.3</strong>。</p>
<p>vux-loader 工具是针对webpack+vue-loader项目的工程化工具，简化了webpack插件和loader的使用和编写，支持在vue-loader处理之前进行预处理，同时内置对vux组件专用的配置和优化插件。 详见 vux-loader readme.md</p>
</div>
<h2>简介</h2>
<p><code>VUX</code>（读音 [v’ju:z]，同 <code>views</code>）是基于<code>WeUI</code>和<code>Vue</code>(2.x)开发的移动端UI组件库，主要服务于微信页面。</p>
<p>基于<code>webpack + vue-loader + vux</code>可以快速开发移动端页面，配合<code>vux-loader</code>方便你在<code>WeUI</code>的基础上定制需要的样式。</p>
<p><code>vux-loader</code>保证了组件按需使用，因此不用担心最终打包了整个vux的组件库代码。</p>
<p><code>VUX</code>并不完全依赖于<code>WeUI</code>，<code>VUX</code> 在 <code>WeUI</code> 的基础上扩展了多个常用组件，但是尽量保持整体UI样式接近<code>WeUI</code>的设计规范。</p>
<div class="warning">
<p>VUX 并不是一个能解决所有场景的完美解决方案(实际上也没有一个方案能解决所有问题)，也会出现某些<code>bug</code>或者某些特性不支持，所以如果遇到问题麻烦及时<strong>不带情绪正确反馈</strong>，<strong>我们乐于及时解决描述详细方便重现的问题</strong>。<br><br>
即使你不直接使用 <code>VUX</code> 组件代码, 你依然可以参考 VUX 代码来实现自己的组件库。如果一定程度上帮助到了你，那么维护这个项目也就有所意义。</p>
</div>
<h2>提示</h2>
<div class="tip">
<p><code>VUX</code> 是<code>库</code>而非<code>框架</code>，虽然有专用的 <code>vux-loader</code>，但并不影响你自由地使用其他组件库或者工具库。<br><br></p>
<p><code>VUX</code> 使用的 CSS 预处理工具是 <code>less</code>(同 WeUI)，但(利益于 .vue 单文件组件的灵活性)这并不影响你使用 <code>SASS</code> 等其他预处理器。<br><br></p>
<p>用以表示该组件库时请使用大写名字 <code>VUX</code>，用在说明版本号时使用小写 <code>vux@2.x</code>。</p>
</div>
</div></template><script>
export default {
  head: {"title":"关于 VUX | VUX - Vue 移动端 UI 组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// README-31.vue?1f1e5dd0